import { icons } from '@lifebit-ai/lds'
import styled from 'styled-components'

export const Container = styled.span`
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => theme.size.space['01']};
`

export const ApprovedIcon = styled(icons.CheckInCircleSmall)`
  path {
    fill: ${({ theme }) => theme.color.feedback.success.default};
  }
`

export const WarningIcon = styled(icons.WarningSmall)`
  path {
    fill: ${({ theme }) => theme.color.feedback.warning.default};
  }
`

export const InfoIcon = styled(icons.InfoSmall)`
  path {
    fill: ${({ theme }) => theme.color.feedback.danger.default};
  }
`
